import React from "react";
import { RadioButton } from "primereact/radiobutton";
import {
  EmergencyCall,
  EmergencyCallGerman,
} from "../../../api/firebase/types/incident.types";

type EmergencyOptionSelectionProps = {
  selectedEmergencyCall?: EmergencyCall;
  emergencyOptions: EmergencyCall[];
  onChange: (emergencyCall: EmergencyCall) => void;
};

const EmergencyOptionSelection: React.FC<EmergencyOptionSelectionProps> = (
  props
) => {
  const emergencyCallRadioButton = (emergencyCall: EmergencyCall) => (
    <div key={emergencyCall} className="setting-entry">
      <RadioButton
        id="emergencyCall"
        value={emergencyCall}
        name={EmergencyCallGerman[emergencyCall]}
        inputId={emergencyCall}
        onChange={(e) => props.onChange(e.value)}
        checked={props.selectedEmergencyCall === EmergencyCall[emergencyCall]}
      />
      <label htmlFor={emergencyCall}>
        {EmergencyCallGerman[emergencyCall]}
      </label>
    </div>
  );

  const renderContent = () => {
    if (props.emergencyOptions.length === 0)
      return (
        <div className="setting-entry">
          <i>Keine Notrufleitstelle verfügbar</i>
        </div>
      );
    if (props.emergencyOptions.length === 1) {
      const onlyEmergencyOption = props.emergencyOptions[0];
      return (
        <div className="setting-entry">
          {EmergencyCallGerman[onlyEmergencyOption]}
        </div>
      );
    }
    return (
      <>
        <p>
          Wählen Sie aus, welche offizielle Leitstelle Ihren Notruf empfangen
          soll.
        </p>
        {props.emergencyOptions.map((emergencyCall) =>
          emergencyCallRadioButton(EmergencyCall[emergencyCall])
        )}
      </>
    );
  };

  return (
    <div className="device-setting-group">
      <b>Notrufleitstelle</b>
      {renderContent()}
    </div>
  );
};
export default EmergencyOptionSelection;
